import React, { createContext, useState, useEffect } from 'react';
import useFetchPlaces from '../hooks/useFetchPlaces';
import { applySorting, applyFilters, getActiveFiltersCount } from '../utils/placesFilterUtils';

export const PlacesContext = createContext();

const PlacesProvider = ({ children }) => {
	const { places, loading, error } = useFetchPlaces();

	const [nameQuery, setNameQuery] = useState('');
	const [currentMapBounds, setCurrentMapBounds] = useState(null);
	const [displayedPlaces, setDisplayedPlaces] = useState([]);
	const [sortBy, setSortBy] = useState('name');
	const [visibleCount, setVisibleCount] = useState(12);
	const itemsPerPage = 12;
	const [viewMode, setViewMode] = useState('gallery');

	const [filters, setFilters] = useState({
		amenities: [],
		rating: 0,
		propertyTypes: [],
		rooms: { bedrooms: 0, beds: 0, bathrooms: 0 },
		bookingOptions: [],
		seasons: [],
	});

	const updateFilters = (newFilters) => {
		setFilters((prevFilters) => ({
			...prevFilters,
			...newFilters,
		}));
	};

	const clearFilters = () => {
		setFilters({
			amenities: [],
			rating: 0,
			propertyTypes: [],
			rooms: { bedrooms: 0, beds: 0, bathrooms: 0 },
			bookingOptions: [],
			seasons: [],
		});
	};

	const loadMore = () => {
		setVisibleCount((prev) => prev + itemsPerPage);
	};

	const countActiveFilters = () => getActiveFiltersCount({ nameQuery, filters });

	useEffect(() => {
		setVisibleCount(12);
	}, [nameQuery, currentMapBounds, filters, sortBy]);

	useEffect(() => {
		const filteredResult = applyFilters(places, nameQuery, currentMapBounds, filters);
		const sortedResult = applySorting(filteredResult, sortBy);
		setDisplayedPlaces(sortedResult);
	}, [places, nameQuery, currentMapBounds, filters, sortBy]);

	return (
		<PlacesContext.Provider
			value={{
				places,
				loading,
				error,
				displayedPlaces,
				setNameQuery,
				setCurrentMapBounds,
				nameQuery,
				currentMapBounds,
				filters,
				updateFilters,
				clearFilters,
				sortBy,
				setSortBy,
				visibleCount,
				setVisibleCount,
				itemsPerPage,
				loadMore,
				getActiveFiltersCount: countActiveFilters,
				viewMode,
				setViewMode,
			}}
		>
			{children}
		</PlacesContext.Provider>
	);
};

export default PlacesProvider;
